/**
 * Shade picker: swatch image plus name, both in the closed state and in the
 * open list - neither of which a native <select> can render.
 *
 * The <select> stays in the DOM as the source of truth and every choice is
 * written back to it with a bubbling change event, so the variant scripts that
 * already listen to #color-select keep working untouched. Without JS, or
 * outside the refreshed layout, the native select is what renders.
 */
(function () {
  var panel = document.querySelector('.product--details-refreshed .shade-select');
  if (!panel) return;

  var select = panel.querySelector('#color-select');
  var chip = panel.querySelector('.shade-select__chip');
  if (!select || !chip || !select.options.length) return;

  function swatchFor(value) {
    var img = document.querySelector('.swatches img[data-options="' + value + '"]');
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
  }

  function paint(el, value) {
    var src = swatchFor(value);
    el.style.backgroundImage = src ? 'url("' + src + '")' : '';
  }

  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'shade-select__toggle';
  toggle.setAttribute('aria-haspopup', 'listbox');
  toggle.setAttribute('aria-expanded', 'false');

  var name = document.createElement('span');
  name.className = 'shade-select__name';
  toggle.appendChild(chip);
  toggle.appendChild(name);

  var list = document.createElement('ul');
  list.className = 'shade-select__list';
  list.setAttribute('role', 'listbox');
  list.hidden = true;

  var options = [];
  Array.prototype.forEach.call(select.options, function (option) {
    var item = document.createElement('li');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'shade-select__option';
    button.setAttribute('role', 'option');
    button.dataset.value = option.value;

    var swatch = document.createElement('span');
    swatch.className = 'shade-select__swatch';
    var label = document.createElement('span');
    label.textContent = option.textContent.trim();

    button.appendChild(swatch);
    button.appendChild(label);
    item.appendChild(button);
    list.appendChild(item);
    options.push({ item: item, button: button, swatch: swatch, value: option.value });
  });

  select.setAttribute('tabindex', '-1');
  select.setAttribute('aria-hidden', 'true');
  panel.classList.add('shade-select--enhanced');
  select.insertAdjacentElement('afterend', toggle);
  toggle.insertAdjacentElement('afterend', list);

  // The category tabs rebuild the select with only that category's options.
  // Offer the same set here, or picking a shade the select no longer has
  // leaves it with no selection and a blank name.
  function hasOption(value) {
    return Array.prototype.some.call(select.options, function (option) {
      return option.value === value;
    });
  }

  function sync() {
    var current = select.options[select.selectedIndex];
    name.textContent = current ? current.textContent.trim() : '';
    paint(chip, select.value);
    options.forEach(function (entry) {
      entry.item.hidden = !hasOption(entry.value);
      entry.button.setAttribute('aria-selected', entry.value === select.value ? 'true' : 'false');
      paint(entry.swatch, entry.value);
    });
  }

  function open(state) {
    list.hidden = !state;
    toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
    panel.classList.toggle('shade-select--open', state);
    if (state) {
      var selected = list.querySelector('[aria-selected="true"]');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }
  }

  toggle.addEventListener('click', function () {
    open(list.hidden);
  });

  list.addEventListener('click', function (event) {
    var button = event.target.closest('.shade-select__option');
    if (!button || !hasOption(button.dataset.value)) return;
    select.value = button.dataset.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    open(false);
    toggle.focus();
    sync();
  });

  list.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    var buttons = options
      .filter(function (entry) { return !entry.item.hidden; })
      .map(function (entry) { return entry.button; });
    var next = buttons.indexOf(document.activeElement) + (event.key === 'ArrowDown' ? 1 : -1);
    if (buttons[next]) buttons[next].focus();
  });

  document.addEventListener('click', function (event) {
    if (!panel.contains(event.target)) open(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !list.hidden) {
      open(false);
      toggle.focus();
    }
  });

  // A swatch click updates the select without going through this UI.
  select.addEventListener('change', sync);
  document.addEventListener('change', function (event) {
    if (event.target.closest('.swatches')) window.setTimeout(sync, 0);
  });
  // Tab clicks swap the options without a change event.
  new MutationObserver(sync).observe(select, { childList: true });
  window.addEventListener('load', sync);
  sync();
})();
